{
	"title": "Judged results",
	"note": {
		"rule": "{{rule}}: type each judge's marks. The score, the dropped marks, the rank and a bout's winner are worked out as you type.",
		"manual": "Type the total. Stored judges' scores are shown under the row and can't be edited here."
	},
	"rule": {
		"KATA_POINTS": "Kata by points (7 judges, 2 high and 2 low dropped, 70% technical + 30% athletic)",
		"KATA_FLAGS": "Kata bout (each judge's higher mark is a vote)",
		"SILAT_SENI": "Seni (middle marks averaged, minus the foul; lower SD wins a tie)",
		"TAOLU": "Taolu (A + B + C + bonus − deduction)",
		"TAOLU_COMBINED": "Taolu, two routines (routine 1 + routine 2)",
		"POOMSAE": "Poomsae (accuracy + presentation, high and low dropped, poomsae averaged)",
		"POOMSAE_FREESTYLE": "Freestyle poomsae (technical skills + presentation)",
		"DANCE_SKATING": "Dancesport final (each judge places the couples, the Skating System decides)",
		"DANCE_RECALLS": "Dancesport round (each judge's cross; most crosses go through)",
		"BREAKING_BATTLE": "Breaking battle (judges vote each round, most rounds win)",
		"JUDO_KATA": "Judo kata (5 judges' totals, high and low dropped)",
		"WAI_KRU": "Wai kru (judges' marks averaged, high and low dropped with 5)",
		"DRESSAGE": "Dressage (judges' percentages averaged)",
		"DRESSAGE_TEAM": "Team dressage (the best riders' percentages count)",
		"FIGURE_SKATING": "Figure skating (TES + PCS × factor − deductions, short + free)",
		"WAKEBOARD": "Wakeboard (judges' totals averaged)",
		"MANUAL": "Typed total"
	},
	"columns": {
		"result": "Score",
		"resultUnit": "Score ({{unit}})",
		"tie": "Tie order",
		"tieLong": "Your order among rows still level after the tie-breaks (1 = ahead)"
	},
	"panel": {
		"toggle": "Judges' marks",
		"toggleFor": "Judges' marks for {{name}}",
		"expandAll": "Show all judges' marks",
		"collapseAll": "Hide judges' marks",
		"group": "Judges {{group}}",
		"groupPlain": "Judges",
		"name": "Name",
		"namePlaceholder": "Kata / form",
		"computed": "Worked out",
		"dropped": "Dropped",
		"notCounted": "Not counted",
		"place": "Place {{place}}",
		"total": "Score",
		"voteFor": "1 = the judge voted for this side"
	},
	"field": {
		"difficulty": "TES",
		"penalty": "Penalty",
		"total": "Score"
	},
	"component": {
		"median": "Median",
		"standard_deviation": "SD",
		"a_quality": "A (quality)",
		"b_performance": "B (performance)",
		"c_difficulty": "C (difficulty)",
		"bonus": "Bonus",
		"technical": "Technical",
		"athletic": "Athletic",
		"accuracy": "Accuracy",
		"presentation": "Presentation",
		"technical_skills": "Technical skills",
		"votes": "Votes",
		"won": "Round won",
		"crosses": "Crosses",
		"mean": "Mean",
		"collective": "Collective marks",
		"forgotten": "Forgotten",
		"big_mistakes": "Big mistakes",
		"composition": "Composition",
		"skating_skills": "Skating skills",
		"pcs": "PCS",
		"execution": "Execution"
	},
	"aria": {
		"seat": "{{seat}}, {{part}}, {{name}}",
		"field": "{{field}}, {{part}}, {{name}}",
		"label": "Name of {{part}}, {{name}}",
		"total": "Score, {{name}}",
		"tie": "Tie order, {{name}}"
	},
	"tieHint": "Level after the tie-breaks: set the order",
	"settings": {
		"label": "Judging options",
		"judges": "Judges",
		"edit": "Judging options",
		"rule": "Scoring",
		"ruleAuto": "Automatic ({{rule}})",
		"rounds": "Rounds per battle",
		"counting": "Riders counted",
		"save": "Save",
		"saved": "Judging options saved",
		"stale": "Someone changed this meet. Reload it and try again.",
		"invalid": "Judges: a whole number from 1 to {{max}}; rounds 1 to 5; riders counted 1 to 12."
	},
	"ruleShort": {
		"KATA_POINTS": "Kata by points",
		"KATA_FLAGS": "Kata bout (votes)",
		"SILAT_SENI": "Seni",
		"TAOLU": "Taolu",
		"TAOLU_COMBINED": "Taolu, two routines",
		"POOMSAE": "Poomsae",
		"POOMSAE_FREESTYLE": "Freestyle poomsae",
		"DANCE_SKATING": "Dancesport final (Skating System)",
		"DANCE_RECALLS": "Dancesport round (crosses)",
		"BREAKING_BATTLE": "Breaking battle",
		"JUDO_KATA": "Judo kata",
		"WAI_KRU": "Wai kru",
		"DRESSAGE": "Dressage",
		"DRESSAGE_TEAM": "Team dressage",
		"FIGURE_SKATING": "Figure skating",
		"WAKEBOARD": "Wakeboard",
		"MANUAL": "Typed total"
	}
}
